import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { ConsumedProjectItemEntity } from './consumed-project-item.entity';

export interface IConsumedProjectListExtra
	extends IListColumnConfig<ConsumedProjectItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface IConsumedProjectListEntity
	extends IListAttrs<ConsumedProjectItemEntity> {
	availableColumns: Map<string, IConsumedProjectListExtra>;
}

const entityDefaults: IConsumedProjectListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ConsumedProjectListEntity
	implements
		IConsumedProjectListEntity,
		IListOperations<ConsumedProjectListEntity, ConsumedProjectItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IConsumedProjectListExtra>
	): ConsumedProjectListEntity {
		const inst = new ConsumedProjectListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IConsumedProjectListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ConsumedProjectItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(
		elems: Map<string, ConsumedProjectItemEntity>
	): ConsumedProjectListEntity {
		return produce(this, (draft: ConsumedProjectListEntity) => {
			draft.elements = elems;
		});
	}
}
